import { Quote, Sparkles, Cpu } from 'lucide-react';

export default function FoundersNote() {
  return (
    <section className="py-12 px-4 relative overflow-hidden">
      <div className="max-w-3xl mx-auto">
        <div className="glass-strong rounded-[28px] p-8 sm:p-10 relative overflow-hidden" data-testid="founders-note">
          <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-[#6C4CF1]/10 blur-3xl" />
          <div className="absolute -bottom-10 -left-10 w-40 h-40 rounded-full bg-[#FFD84D]/20 blur-3xl" />
          <Quote className="absolute top-6 right-6 w-16 h-16 text-[#6C4CF1]/8" />

          <div className="relative">
            <div className="flex items-center gap-2 mb-4">
              <Sparkles className="w-4 h-4 text-[#FFC93C]" />
              <span className="text-[10px] font-bold tracking-[0.2em] text-[#6C4CF1] uppercase">A Note from the Founder</span>
            </div>
            <h2 className="text-2xl sm:text-3xl font-bold text-[#0A0A0A] mb-5 leading-tight" style={{ fontFamily: 'Poppins' }}>
              The worker problem is broken in India. <br/>
              <span className="text-[#6C4CF1]">We're the first to fix it with AI.</span>
            </h2>
            <div className="space-y-4 text-sm leading-relaxed text-[#4B5563]">
              <p>
                Every Indian home has the same story — a maid who stops showing up, a cook who calls in sick on the day you have guests, a bathroom no one cleans for a week. The status quo is broken on <b>both</b> sides: workers are paid late and treated poorly, customers are left with no shows and no accountability.
              </p>
              <p>
                We started GharSetGo because the home-services market in India had never been rebuilt with technology the way Uber rebuilt taxis. Listing apps didn't fix the problem. We did — <b className="text-[#0A0A0A]">GharSetGo is the first hyperlocal home-services platform with AI baked into every layer</b> — matching, dispatch, route-planning, quality scoring, mess detection, even routine reminders.
              </p>
              <p>
                For workers: instant onboarding, transparent payouts, daily jobs, fair commission. For homes: three-tap booking, a live map, a verified pro at your door, and a smart floor map that tells you when a room needs attention before you do. <b className="text-[#0A0A0A]">Ghar set, zindagi go.</b>
              </p>
              <p>
                We're starting in Ahmedabad. We're coming to your city next.
              </p>
              <div className="mt-3 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#F3EEFF] border border-[#6C4CF1]/15">
                <Cpu className="w-3.5 h-3.5 text-[#6C4CF1]" />
                <span className="text-[10px] font-bold tracking-[0.18em] uppercase text-[#6C4CF1]">India's first AI-native home services platform</span>
              </div>
            </div>
            <div className="mt-6 flex items-center gap-3 pt-5 border-t border-[#E5E7EB]">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#6C4CF1] to-[#8B5CF6] flex items-center justify-center text-white font-bold text-lg" style={{ fontFamily: 'Poppins' }}>RS</div>
              <div>
                <p className="text-sm font-bold text-[#0A0A0A]" style={{ fontFamily: 'Poppins' }}>— Rishit Shah</p>
                <p className="text-[10px] text-[#9CA3AF]">Founder, GharSetGo · Ahmedabad · India · 2026</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
